import React, { useContext, useMemo } from "react";
import { theme, Typography } from "antd";
import { ShopOutlined } from "@ant-design/icons";
import CoreLogo3D from "../global-admin/CoreLogo3D";
import { useBreakpoint } from "../../utils/breakpoints";
import { AppContext } from "../../App";

const { Text } = Typography;

const Logo = () => {
  const breakpoint = useBreakpoint();
  const { state } = useContext(AppContext);
  const { token } = theme.useToken();

  // Verificar si el usuario tiene un rol específico de sucursal
  const hasBranchRole = useMemo(() => {
    return state.user?.branch_assignments?.some(
      (assignment) => assignment.is_active && assignment.role
    );
  }, [state.user?.branch_assignments]);

  // Si el usuario tiene un rol específico de sucursal, NO mostrar nada aquí
  // El nombre de la sucursal se muestra en GlobalBranchSwitcher
  if (hasBranchRole) {
    return null;
  }

  // Solo mostrar icono animado si es super admin sin rol de sucursal
  // Usar siempre el tipo de logo global animado
  const kind = state.globalLogoType || "nucleus";
  const size = breakpoint === "xs" || breakpoint === "sm" ? 40 : 52;

  if (kind === "rocket") {
    const w = size + 10;
    const h = size + 2;
    return (
      <div
        style={{
          width: w,
          height: h,
          animation: "rocket-drift 2.8s ease-in-out infinite",
        }}
      >
        <svg
          width={w}
          height={h}
          viewBox="0 0 100 100"
          role="img"
          aria-hidden="true"
          style={{ display: "block" }}
        >
          <defs>
            <linearGradient id="flame" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#ffd966" />
              <stop offset="60%" stopColor="#ff6f3d" />
              <stop offset="100%" stopColor="#d4380d" />
            </linearGradient>
            <filter id="glow" x="-40%" y="-40%" width="180%" height="180%">
              <feGaussianBlur stdDeviation="2.1" result="blur" />
              <feColorMatrix in="blur" type="matrix" values="
                1 0 0 0 0
                0 1 0 0 0
                0 0 1 0 0
                0 0 0 12 -6
              " result="glow"/>
              <feMerge>
                <feMergeNode in="glow" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          <g>
            <circle cx="18" cy="22" r="1.2" fill="#fff" opacity="0.8" />
            <circle cx="82" cy="18" r="1" fill="#fff" opacity="0.7" />
            <circle cx="14" cy="74" r="1" fill="#fff" opacity="0.6" />
            <circle cx="88" cy="68" r="1.2" fill="#fff" opacity="0.75" />
          </g>
          <g filter="url(#glow)">
            <path d="M64 72 C58 65, 52 65, 46 72" stroke="url(#flame)" strokeWidth="2" fill="none" opacity="0.7"/>
          </g>
          <g>
            <path d="M50 22 L58 36 L58 54 L50 60 L42 54 L42 36 Z"
              fill={token.colorPrimary}
              stroke={token.colorPrimary}
              strokeOpacity="0.85"
            />
            <circle cx="50" cy="42" r="6" fill="#fff" opacity="0.9" />
            <path d="M42 54 L50 72 L58 54" fill="url(#flame)" opacity="0.95" />
          </g>
        </svg>
        <style>
          {`@keyframes rocket-drift {
            0%, 100% {
              transform: translateY(0) translateX(0) rotate(-18deg);
            }
            50% {
              transform: translateY(-4px) translateX(3px) rotate(-18deg);
            }
          }`}
        </style>
      </div>
    );
  }

  if (kind === "orbit") {
    return <CoreLogo3D size={size} variant="orbit" />;
  }

  return <CoreLogo3D size={size} variant="nucleus" />;
};

export default Logo;